import { render } from "./goodsManage.vue?vue&type=template&id=ef4e212c"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__